/**
 * Stores the current APNs device token for unregister on logout and re-register after login.
 * - currentPushDeviceToken: cleared on logout so we don't re-register stale; set when we register.
 * - lastKnownPushToken: never cleared so we can re-register after login if the plugin doesn't re-emit.
 */
let currentPushDeviceToken: string | null = null;
let lastKnownPushToken: string | null = null;

export function setPushDeviceToken(token: string | null): void {
  currentPushDeviceToken = token ?? null;
  if (token) lastKnownPushToken = token;
}

export function getPushDeviceToken(): string | null {
  return currentPushDeviceToken;
}

/** Token last received from the plugin; kept across logout so we can re-register after login. */
export function getLastKnownPushToken(): string | null {
  return lastKnownPushToken;
}
